import { Banner, BrandLoader, Button } from '@acs/ui';
import { useI18n } from '../../i18n/index.js';
import type { useCheckoutReturn } from './useCheckoutReturn.js';

/**
 * Paid at Stripe, not yet visible here (`useCheckoutReturn`). Payment went
 * through — Stripe would not have sent the owner back otherwise — so this
 * waits for the webhook, with one way to ask again. Never suggests a failure.
 */
export function CheckoutConfirming({ ret }: { ret: ReturnType<typeof useCheckoutReturn> }) {
  const { t } = useI18n();
  return ret.stalled ? (
    <Banner
      tone="info"
      title={t('billing.done.pending.title')}
      actions={
        <Button variant="secondary" loading={ret.checking} onClick={ret.checkAgain}>
          {t('plan.prep.checkAgain')}
        </Button>
      }
    >
      {t('billing.done.confirming')}
    </Banner>
  ) : (
    <p className="row" style={{ gap: 10, flexWrap: 'nowrap' }}>
      <BrandLoader size={24} />
      <span className="muted">{t('billing.done.confirming')}</span>
    </p>
  );
}
